































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { AppAuthorization } from "../api/types";

@Component({
  name: "app-authorizations-table",
  components: {},
})
export default class AppAuthorizationsTable extends Vue {
  @Prop({ default: [] })
  authorizations: AppAuthorization[];

  @Prop({ default: false })
  loading: boolean;

  mounted() {}

  deleteAuthorization(authorizationId) {
    this.$emit("delete-authorization", authorizationId);
  }
}
